"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigDescriptionLink = void 0;
const tslib_1 = require("tslib");
const css_1 = require("@emotion/css");
const react_1 = tslib_1.__importDefault(require("react"));
const ui_1 = require("@grafana/ui");
function ConfigDescriptionLink(props) {
    const { description, suffix, feature } = props;
    const text = `Learn more about ${feature}`;
    const styles = (0, ui_1.useStyles2)(getStyles);
    return (react_1.default.createElement("span", { className: styles.container },
        description,
        react_1.default.createElement("a", { "aria-label": text, href: `https://grafana.com/docs/grafana/next/datasources/${suffix}`, rel: "noreferrer", target: "_blank" }, text)));
}
exports.ConfigDescriptionLink = ConfigDescriptionLink;
const getStyles = (theme) => {
    return {
        container: (0, css_1.css)({
            color: theme.colors.text.secondary,
            a: (0, css_1.css)({
                color: theme.colors.text.link,
                textDecoration: 'underline',
                marginLeft: '5px',
                '&:hover': {
                    textDecoration: 'none',
                },
            }),
        }),
    };
};
//# sourceMappingURL=ConfigDescriptionLink.js.map